{
  "hero": {
    "eyebrow": "2026-27 {{fundraiserName}} Fundraiser",
    "heading": "A Fundraiser for {{fundraiserName}}.<br/>A planner for you.",
    "description": "A digital and printable planner with your district dates already filled in.",
    "checks": [
      "No-school days, already shaded.",
      "Add your own important dates.",
      "A portion of every sale goes directly to {{fundraiserName}}.",
      "Sync to Google, Apple or Outlook."
    ],
    "planner_image_alt": "Planner: monthly and weekly pages"
  },
  "benefits": {
    "eyebrow": "What's inside",
    "heading": "The school year, already there.<br/>Add your dates, too.",
    "items": [
      {
        "eyebrow": "No retyping",
        "title": "Nothing typed twice.",
        "body": "Upload a PDF, snap the backpack flyer, or paste an email. We file the dates for you."
      },
      {
        "eyebrow": "All of life",
        "title": "Not just school.",
        "body": "Soccer, piano, the orthodontist. The rest of your life goes on top."
      },
      {
        "eyebrow": "Anywhere",
        "title": "Digital and printable.",
        "body": "On your phone in the carpool line. On the fridge for everyone else."
      },
      {
        "eyebrow": "Together",
        "title": "Share or co-edit.",
        "body": "View-only for grandparents. Full editing for your co-parent."
      },
      {
        "eyebrow": "Exports",
        "title": "Works with your calendar.",
        "body": "Exports to Google, Outlook, and Apple."
      },
      {
        "eyebrow": "Fast start",
        "title": "Set up in minutes.",
        "body": "No training, import or learning curve."
      }
    ]
  },
  "faq": {
    "eyebrow": "Common questions",
    "heading": "Anything else?",
    "items": [
      {
        "question": "How much does a digital and printable planner cost?",
        "answer": "$30 and it's yours for the year. School dates pre-populated, add as much of your own content as you want and print as many times as you need."
      },
      {
        "question": "I lead a PTA. Can I set up a fundraiser for my PTA?",
        "answer": "Yes, of course! Contact schools@agendahero.com to let us know you're interested. We generate your fundraiser code with share-ready materials. You distribute to your community. A portion of every sale goes directly back to your PTA."
      },
      {
        "question": "How do I add my own content to my planner?",
        "answer": "You upload pdfs, images or paste text. Agenda Hero pulls out the important date information and adds it to your planner. You can also send this information to Google, Apple or Outlook from the platform."
      }
    ]
  },
  "final_cta": {
    "heading": "More time for joy.",
    "description": "12 Months. 52 Weeks. Done for You.",
    "price_line": "One payment · Yours for the school year"
  },
  "footer": {
    "help": "Help",
    "terms": "Terms",
    "privacy": "Privacy"
  },
  "checkout": {
    "label_package": "Get your planner • $30",
    "cta_aria": "Get your planner"
  }
}
